module.exports = __webpack_public_path__ + "img/people blue.dce21ab9.svg";